module.exports = __webpack_public_path__ + "static/landingi-8aa0e705ceec9c826bc58de8ac2619db.png";